import { CenteringDiv, FlexRowDiv, H3, P } from 'components/generic/HomePageComponents'

const WhoWeAre = ({ heading, content }) => (
  <FlexRowDiv pt='100px' pb='100px' borderBottom='1px solid #f7f7f7'>
    <CenteringDiv justifyContent='flex-start'>
      <H3
        fontWeight='bold'
        fontSize={{ _: '28px', tablet: '38px' }}
        mt='10px'
        mb='10px'
        textAlign='center'
      >
        {heading}
      </H3>
      <P
        fontSize='20px'
        textAlign='center'
        p='0'
        m='0'
        maxWidth='66%'
        lineHeight='1.4'
        color='darkGrey'
      >
        {content}
      </P>
    </CenteringDiv>
  </FlexRowDiv>
)

export default WhoWeAre
